import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'


const styles = () => ({
  root: {
    marginTop: 30,
    width: '100%',
    display: 'flex',
    marginBottom: 30,
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  title: {
    width: 'auto',
    marginLeft: 10,
    marginRight: 30,
    display: 'inline-block',
  },
  hrBefore: {
    height: 1,
    width: 15,
    background: '#d9dee3',
  },
  hrAfter: {
    flex: 1,
    height: 1,
    background: '#d9dee3',
  },
})


const Line = ({
  classes,
  children,
  className,
}) => (
  <div className={classNames(classes.root, className)}>
    <hr className={classes.hrBefore} />
    <Typography className={classes.title} color="textSecondary">{children}</Typography>
    <hr className={classes.hrAfter} />
  </div>
)


Line.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Line)
